import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router";
import { setTeamNameOfSelectedPlayer } from "../../../../redux";
import PlayerInformation from "../PlayerInformation/PlayerInformation";
import PlayerInformationEnd from "../PlayerInformationEnd/PlayerInformationEnd";
import PlayerStatsInformation from "../PlayerStatsInformation/PlayerStatsInformation";

function SingleCardComponent(props) {
  // console.log("single component props", props);
  const [playerInfo, setPlayerInfo] = React.useState(props.player_info);
  const [shouldHideComponent, setShouldHideComponent] = React.useState(false);
  // This will launch only if propName value has chaged.

  React.useEffect(() => {
    setPlayerInfo(props.player_info);
    // console.log("playerInfo", playerInfo);
  }, [
    // props.game_information.gameInformationReducer.display_players,
    shouldHideComponent,
    props.player_info,
  ]);
  function setSelectedPlayerTeam(team) {
    props.teamname_setter(team);
  }
  return (
    <>
      {shouldHideComponent === true ? null : (
        <>
          <div
            // key={props.player_info.OperatorPlayerID}
            className="border-bottom"
          >
            <div className="d-flex bg-black">
              <Link
                className="playerInformation__link"
                onClick={() => setSelectedPlayerTeam(playerInfo.Team)}
                to={
                  playerInfo.SSID ?
                  "/app/" +
                  props.game_information.gameInformationReducer.sports +
                  "/player/" +
                  playerInfo.SSID : ""
                }
                // to={"/player/" + player_info.PlayerID}
              >
                <PlayerInformation
                  player_information_props={playerInfo}
                  key={playerInfo.OperatorPlayerID}
                />
              </Link>

              <PlayerInformationEnd
                player_information_props={playerInfo}
                key={playerInfo.OperatorPlayerID}
                operator_player_id={playerInfo.OperatorPlayerID}
                player_id={playerInfo.PlayerID}
                setShouldHideComponent={setShouldHideComponent}
                show_lock_exclude={props.show_lock_exclude}
              />
            </div>
            {/*
                Use Link instead of anchor tag.
                Video for reference: https://www.youtube.com/watch?v=AILU8hl-dmo&ab_channel=TheNetNinja
              */}
            <PlayerStatsInformation
              player_stats={playerInfo}
              key={playerInfo.OperatorPlayerID}
              background_dark={false}
              show_bottom_border={true}
              lineup_card={false}
            />
          </div>
        </>
      )}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    game_information: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    teamname_setter: (value) => dispatch(setTeamNameOfSelectedPlayer(value)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleCardComponent);
